/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DefaultContainerLayout } from '@/data/types/ContainerLayout';
import ProductListingPage from '@/data/containers/default/ProductListingPage';
import Error404Page from '@/data/containers/default/Error404Page';

export const defaultContainerLayoutManifestCustom: {
	[pageType: string]: DefaultContainerLayout;
} = {
	CategoryPage: ProductListingPage,
	Error404Page:Error404Page,
};
